export enum MandantAttributeType {
  ENABLE_RESERVATION_EDIT = "EnableReservationEdit",
  ENABLE_ROOM_TYPE_EDIT = "EnableRoomTypeEdit",
  ENABLE_RATE_EDIT = "EnableRateEdit",
  ENABLE_AVAILABILITY_EDIT = "EnableAvailabilityEdit",
  ENABLE_GUEST_EDIT = "EnableGuestEdit",
  ENABLE_DETAIL_PAGE_EDIT = "EnableDetailPageEdit",
  ENABLE_EXTRAS_EDIT = "EnableAdditionalServicesEdit",
  ENABLE_ROOM_PLAN = "EnableRoomPlan",
  ENABLE_RECEPTION = "EnableReception",
  ENABLE_PRICE_LIST = "EnablePriceList",
  ROOM_PLAN = "RoomPlan",
  BOOKED = "Booked",
  RECEPTION_ROOMS = "ReceptionRooms",
  RECEPTION_ASA = "ReceptionAsa",
  RECEPTION_AUTO = "ReceptionAuto",
  LAST_MINUTE = "LastMinute",
  ENABLE_LAST_MINUTE = "EnableLastMinute",
  RECEPTION_TOURISTMANAGER = "ReceptionTouristmanager",
  ENABLE_ROOM_PLAN_VIEW = "EnableRoomPlanView",
  CHECKIN = "CheckIn",
  ENABLE_TRANSACTIONS = "EnableTransactions",
}
